import { useEffect, useState } from "react";
import styled from "styled-components";

function ScrollIndicator() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const update = () => {
      const scrollTop =
        window.scrollY || document.documentElement.scrollTop || 0;
      const docHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      const ratio = docHeight > 0 ? scrollTop / docHeight : 0;
      setProgress(Math.min(1, Math.max(0, ratio)));
    };

    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, []);

  return (
    <Track aria-hidden="true">
      <Bar style={{ transform: `scaleX(${progress})` }} />
    </Track>
  );
}

const Track = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: transparent;
  z-index: ${({ theme }) => theme.zIndex.sticky + 1};
  pointer-events: none;
`;

const Bar = styled.div`
  height: 100%;
  width: 100%;
  transform-origin: 0 50%;
  transform: scaleX(0);
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.primaryLight},
    ${({ theme }) => theme.colors.gold}
  );
  box-shadow: 0 0 12px rgba(201, 169, 110, 0.45);
  transition: transform 80ms linear;
`;

export default ScrollIndicator;
